import { Haptics, ImpactStyle } from '@capacitor/haptics';
import { isNative } from '@/lib/platform';

export async function hapticComplete(): Promise<void> {
  if (!isNative()) return;
  try {
    await Haptics.impact({ style: ImpactStyle.Medium });
  } catch {
    /* haptic failure must not abort the user action */
  }
}

export async function hapticSkip(): Promise<void> {
  if (!isNative()) return;
  try {
    await Haptics.impact({ style: ImpactStyle.Light });
  } catch {
    /* haptic failure must not abort the user action */
  }
}

export async function hapticSubtaskCheck(): Promise<void> {
  if (!isNative()) return;
  try {
    await Haptics.selectionChanged();
  } catch {
    /* haptic failure must not abort the user action */
  }
}

export async function hapticTap(): Promise<void> {
  if (!isNative()) return;
  try {
    await Haptics.impact({ style: ImpactStyle.Light });
  } catch {
    /* haptic failure must not abort the user action */
  }
}

export async function hapticNav(): Promise<void> {
  if (!isNative()) return;
  try {
    await Haptics.selectionChanged();
  } catch {
    /* haptic failure must not abort the user action */
  }
}

/** Light tap at end of each routine step. Reuses hapticTap intensity. */
export const hapticStepComplete = hapticTap;

/** Medium impact when the whole routine finishes — fires ONCE, never on confetti repeat. */
export async function hapticRoutineComplete(): Promise<void> {
  try {
    await Haptics.impact({ style: ImpactStyle.Medium });
  } catch {
    /* no-op on web */
  }
}

/** Selection-changed fires on drop in the builder's sortable step list. */
export const hapticDragDrop = hapticNav;

/** Light selection feedback — used on tap-to-connect, sync trigger. */
export async function hapticSelection(): Promise<void> {
  if (!isNative()) return;
  try {
    await Haptics.selectionChanged();
  } catch {
    /* no-op */
  }
}

/** Warning haptic — used on destructive confirmation (Disconnect) + sync failure. */
export async function hapticWarning(): Promise<void> {
  if (!isNative()) return;
  try {
    await Haptics.impact({ style: ImpactStyle.Heavy });
  } catch {
    /* no-op */
  }
}
